import { useEffect } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";
import { useSelector } from "react-redux";

import categoryService from "app/common/services/categoryService";
import { NoData } from "app/pages/industry-analysis/frame/NoData";
import { CategoryServiceUtils } from "app/services/CategoryServiceUtils";
import type { ISegmentsModule } from "app/services/segments/segmentsApiService";
import { allTrackers } from "app/services/track/track";

import { extractPrimaryCategoryFromParams } from "../routes/routeUtils";

export const WithSegmentAndDomainsOverlapped = (Component) => {
    return function WrappedComponent(props) {
        const { params } = useCurrentStateAndParams();
        const { category } = params;

        const primaryCategory = extractPrimaryCategoryFromParams(category);
        const categoryObject = categoryService.categoryQueryParamToCategoryObject(primaryCategory);
        const segmentsModule: ISegmentsModule = useSelector((state) => {
            return state.segmentsModule;
        });
        const isSegmentAndDomainsOverlapped = CategoryServiceUtils.isSegmentAndDomainsOverlapped(
            categoryObject,
            segmentsModule,
        );

        useEffect(() => {
            if (!isSegmentAndDomainsOverlapped) {
                return;
            }
            const { categoryId, name } = categoryObject;
            allTrackers.trackEvent(
                "N/A state",
                "Analyze custom industry",
                `contains overlap between a domain and a segment's domain/${name}/${categoryId}`,
            );
        }, [isSegmentAndDomainsOverlapped, categoryObject]);

        if (isSegmentAndDomainsOverlapped) {
            return (
                <NoData
                    noDataTitleKey={"industry.with.segment.and.domain.overlap.title"}
                    noDataSubTitleKey={"industry.with.segment.and.domain.overlap.subtitle"}
                />
            );
        }
        return <Component {...props} />;
    };
};
